module.exports = __webpack_public_path__ + "static/media/Step 4-Select_Chamber_Model.cfca1274.gif";


//////////////////
// WEBPACK FOOTER
// ./src/media/tutorial-images/Step 4-Select_Chamber_Model.gif
// module id = 3042
// module chunks = 0